import type { PullTestPiling } from 'shared_models';

/** API `locationKey` for sibling pilings at one install location (e.g. `PT-12`). */
export function buildPullTestLocationKey(pilePrefix: string, locationSerial: number): string {
  const prefix = String(pilePrefix ?? '').trim();
  return `${prefix}-${locationSerial}`;
}

/** Distinct pile identifiers whose piling `status` is `completed` at a location. */
export function collectCompletedPileIdentifiers(pilings: PullTestPiling[]): Set<string> {
  const out = new Set<string>();
  for (const p of pilings) {
    if (p.status !== 'completed') {
      continue;
    }
    const id = String(p.pileIdentifier ?? '').trim();
    if (id) {
      out.add(id);
    }
  }
  return out;
}
